import * as types from "../actions/actionTypes";
const initialState = {
  initLoading: false,
  initError: "",
  data: {
    prices: [],
    not_fetched: true,
    selected_duration: "",
    trial_flag: "",
    data: [],
    user_wallet: ""
  },

  owner: {},
  calculatePrice: {},
  calculatePriceLoading: false,
  calculatePriceError: "",

  buyGiftLoading: false,

  useWalletLoading: false,
  usePromoCodeLoading: false,

  transactionsListLoading: false,
  transactionsData: { data: [], meta: {} },
  transactionsListError: "",

  payLoading: false,
  payData: [],

  promoCodeLoading: false,
  promoCodeError: "",
  promoCodes: [],

  activePlanLoading: false,
  activePlanError: "",
  activePlans: [],

  loading: false,
  error: "",
  selected: {}
  // initLoading: false,
  // data: {
  //   prices: [],
  //   not_fetched: true
  // },
  // calculatePrice: {},
  // calculatePricePostData: {},
  // calculatePriceLoading: false,
  // calculatePriceError: false,
  // useWalletLoading: false,
  // usePromoCodeLoading: false,
  // list: [],
  // transactionsListLoading:false,
  // listByProject: [],
  // payLoading: false,
  // payData: [],
  // promoCodeLoading: false,
  // promoCodes: [],
  // activePlanLoading: false,
  // activePlans: [],
  // loading: false,
  // selected:{},
  // error:false,
};

const Premium = (state = initialState, action) => {
  switch (action.type) {
    case types.PREMIUM_INIT_REQUEST:
      return { ...state, initLoading: true, initError: "" };
    case types.PREMIUM_INIT_SUCCESS:
      return { ...state, data: action.payLoad, initLoading: false };
    case types.PREMIUM_INIT_FAILURE:
      return { ...state, initLoading: false, initError: action.error };

    case types.PREMIUM_CALCULATE_PRICE_REQUEST:
      return {
        ...state,
        owner: {},
        calculatePrice: {},
        calculatePriceLoading: true,
        calculatePriceError: ""
      };
    case types.PREMIUM_CALCULATE_PRICE_SUCCESS:
      return {
        ...state,
        owner: action.payLoad.owner,
        calculatePrice: action.payLoad.data,
        calculatePriceLoading: false
      };
    case types.PREMIUM_CALCULATE_PRICE_FAILURE:
      return {
        ...state,
        calculatePriceLoading: false,
        calculatePriceError: action.error
      };

    case types.PREMIUM_BUY_GIFT_REQUEST:
      return {
        ...state,
        buyGiftLoading: true
      };
    case types.PREMIUM_BUY_GIFT_SUCCESS:
      return {
        ...state,
        buyGiftLoading: false
      };
    case types.PREMIUM_BUY_GIFT_FAILURE:
      return {
        ...state,
        buyGiftLoading: false
      };

    case types.PREMIUM_USE_WALLET_REQUEST:
      return { ...state, useWalletLoading: true };
    case types.PREMIUM_USE_WALLET_SUCCESS:
      return {
        ...state,
        calculatePrice: action.payLoad,
        useWalletLoading: false
      };
    case types.PREMIUM_USE_WALLET_FAILURE:
      return {
        ...state,
        useWalletLoading: false
      };

    case types.PREMIUM_USE_PROMO_CODE_REQUEST:
      return { ...state, usePromoCodeLoading: true };
    case types.PREMIUM_USE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        calculatePrice: action.payLoad,
        usePromoCodeLoading: false
      };
    case types.PREMIUM_USE_PROMO_CODE_FAILURE:
      return {
        ...state,
        usePromoCodeLoading: false
      };

    case types.PREMIUM_INFO_SAVE_IN_CASH:
      return { ...state, calculatePricePostData: action.data };

    case types.PREMIUM_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
        transactionsListLoading: true,
        transactionsListError: ""
      };
    case types.PREMIUM_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        transactionsData: action.data,
        transactionsListLoading: false
      };
    case types.PREMIUM_TRANSACTION_LIST_FAILURE:
      return {
        ...state,
        transactionsListLoading: false,
        transactionsListError: action.error
      };

    case types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST:
      return { ...state, transactionsListLoading: true };
    case types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_SUCCESS:
      return {
        ...state,
        listByProject: action.payLoad,
        transactionsListLoading: false
      };
    case types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_FAILURE:
      return { ...state, transactionsListLoading: false };

    case types.PREMIUM_PAY_REQUEST:
      return { ...state, payLoading: true };
    case types.PREMIUM_PAY_SUCCESS:
      return { ...state, payData: action.data, payLoading: false };
    case types.PREMIUM_PAY_FAILURE:
      return { ...state, payLoading: false };

    case types.PREMIUM_PROMO_CODE_REQUEST:
      return { ...state, promoCodeLoading: true, promoCodeError: "" };
    case types.PREMIUM_PROMO_CODE_SUCCESS:
      return { ...state, promoCodes: action.data, promoCodeLoading: false };
    case types.PREMIUM_PROMO_CODE_FAILURE:
      return {
        ...state,
        promoCodeLoading: false,
        promoCodeError: action.error
      };

    case types.PREMIUM_ACTIVE_PLANS_REQUEST:
      return { ...state, activePlanLoading: true, activePlanError: "" };
    case types.PREMIUM_ACTIVE_PLANS_SUCCESS:
      return { ...state, activePlans: action.data, activePlanLoading: false };
    case types.PREMIUM_ACTIVE_PLANS_FAILURE:
      return {
        ...state,
        activePlanLoading: false,
        activePlanError: action.error
      };

    case types.PREMIUM_TRANSACTION_ITEM_REQUEST:
      return { ...state, loading: true, error: "", selected: {} };
    case types.PREMIUM_TRANSACTION_ITEM_SUCCESS:
      return { ...state, selected: action.payLoad, loading: false };
    case types.PREMIUM_TRANSACTION_ITEM_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export default Premium;
